import { Injectable, Injector } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, switchMap } from 'rxjs/operators';
import { LoaderService } from './loader.service';
import { CommonService } from 'src/app/service/common.service';
import { HttpService } from 'src/app/service/http.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptorService implements HttpInterceptor {
  constructor(private loaderService: LoaderService, private http: HttpService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!(req.url.includes("plmAnalyticsTable") && req.responseType === 'json')) {
      this.showLoader();
    }
    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            if (!(req.url.includes("plmAnalyticsTable") && req.responseType === 'json')) {
              this.onEnd();
            }
          }
        },
        (err: any) => {
          if (err['status'] == 401 && (err['error']['msg'] == "INVALID_ACCESS_CODE" || req.responseType === 'blob')) {
            this.http.refreshToken().subscribe((res: any) => {
              this.http.localStorageSetItem('admin_token', res['accessToken']);
              this.http.localStorageSetItem('refreshToken', res['refreshToken']);
              location.reload();
            });
          }
          if (!(req.url.includes("plmAnalyticsTable") && req.responseType === 'json')) {
            this.onEnd();
          }
        }
      )
    );
  }

  private onEnd(): void {
    this.hideLoader();
  }

  private showLoader(): void {
    this.loaderService.show();
  }

  private hideLoader(): void {
    this.loaderService.hide();
  }
}
